import { render, staticRenderFns } from "./CandidateAnswerDataComponent.vue?vue&type=template&id=e0396d88&"
import script from "./CandidateAnswerDataComponent.vue?vue&type=script&lang=js&"
export * from "./CandidateAnswerDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports